import axios from 'axios'

class OrderFactory {
  async orders(params: any) {
    try {
      const url = '/orders'
      const response = await axios.get(url, { params })
      return response.data
    } catch (error) {
      console.error(error)
      return false
    }
  }

  async detailOrder(id: any) {
    try {
      const url = `/orders/${id}`
      const response = await axios.get(url)
      return response.data
    } catch (error) {
      console.error(error)
      return false
    }
  }

  async exportOrder(data: any) {
    try {
      const url = '/orders/export'
      const response = await axios.get(url, {
        responseType: 'arraybuffer',
        params: {
          status: data.status,
          date_from: data.date_from,
          date_to: data.date_to,
          keyword: data.keyword,
          order_by: data.order_by,
          order_at: data.order_at,
          child_user_id: data.child_user_id,
          merchant_type: data.merchant_type
        }
      })
      const headers = response.headers

      let filename = 'Ekspor_Riwayat_Pembayaran.xlsx'
      // if content disposition is present
      if (headers['content-disposition']) {
        filename = headers['content-disposition'].split('filename=')[1]
      }

      const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = filename
      link.click()
    } catch (error) {
      console.error(error)
      return false
    }
  }

  async importOrder(data: any) {
    try {
      const url = '/orders/import'
      const response = await axios.post(url, data, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      return response.data
    } catch (error) {
      console.error(error)
      return false
    }
  }

  async importVAOrder(data: any) {
    try {
      const url = '/orders/import-va'
      const response = await axios.post(url, data, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      return response.data
    } catch (error) {
      console.error(error)
      return false
    }
  }

  async importVAExpired(data: any) {
    try {
      const url = '/orders/import-va-expired'
      const response = await axios.post(url, data, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      return response.data
    } catch (error) {
      console.error(error)
      return false
    }
  }

  async savePayment(data: any) {
    try {
      const url = '/orders/payment'
      const response = await axios.post(url, data, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      return response.data
    } catch (error) {
      console.error(error)
      return false
    }
  }

  async templateImport(data: any) {
    try {
      const url = '/orders/template'
      const response = await axios.get(url, {
        responseType: 'arraybuffer',
        params: {}
      })
      const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = 'Template_Impor_Pembayaran.xlsx'
      link.click()
    } catch (error) {
      console.error(error)
      return false
    }
  }

  async downloadVAFileTemplate() {
    try {
      const url = '/orders/import-va/template'
      const response = await axios.get(url, {
        responseType: 'arraybuffer',
        params: {}
      })
      const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = 'Template_VA_Orders.xlsx'
      link.click()
    } catch (error) {
      console.error(error)
      return false
    }
  }

  async expireInvoice(data: any) {
    try {
      const url = '/orders/expire'
      const response = await axios.post(url, data, {
        // headers: {
        //   'Content-Type': 'multipart/form-data'
        // }
      })
      return response.data
    } catch (error) {
      console.error(error)
      return false
    }
  }

  async deleteInvoice(data: any) {
    try {
      const url = '/orders/delete'
      const response = await axios.post(url, data, {
        // headers: {
        //   'Content-Type': 'multipart/form-data'
        // }
      })
      return response.data
    } catch (error) {
      console.error(error)
      return false
    }
  }

  async deleteSelectedInvoice(data: any) {
    try {
      const url = '/orders/delete-selected'
      const response = await axios.post(url, data, {
        // headers: {
        //   'Content-Type': 'multipart/form-data'
        // }
      })
      return response.data
    } catch (error) {
      console.error(error)
      return false
    }
  }

  async refund(id: any, data: any) {
    try {
      const url = `/orders/${id}/refund`
      const response = await axios.post(url, data, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      return response.data
    } catch (error) {
      console.error(error)
      return false
    }
  }

  async refundHistory(id: any) {
    try {
      const url = `/orders/${id}/refunds`
      const response = await axios.get(url)
      return response.data
    } catch (error) {
      console.error(error)
      return false
    }
  }

  async getRefundDetails(id: any) {
    try {
      const url = `/customers/orders/${id}/refund-details`
      const response = await axios.get(url)
      return response.data
    } catch (error) {
      console.error(error)
      return false
    }
  }
}

export const orderFactory = new OrderFactory()
